<template>
    <div class="printUtilApprove-modelDetail"> 
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" class="button-view" icon="el-icon-printer" @click.stop="createPdf()" >导出打印</el-button>
        </span>  
         <div id="printId" >
            <div class="model-content">
                <div class="avatar-wrapper">
                      <img v-if="imageUrl" :src="imageUrl" class="logo-avatar">{{companyName}}
                      <span style="margin-left:30%;font-size: large;" >{{formInfo.formName}}</span>
                      <span style="margin-left:25%;" >{{ '' | getCurrentTime }}</span>
                    <!-- <div style="text-align: center; font-size: large; margin-bottom: 15px;" >{{formInfo.formName}}</div> -->
                </div>
                <div style="width:340mm;">
                  <el-form v-if="isShowApproval" :model="formInfo" label-width="165px"> 
                      <el-row>
                          <div style="margin-top: 20px;float: left;padding-left: 25mm;font-size: large; margin-bottom: 5px;font-size: large;color: #333;font-weight: 700;">基本信息</div>
                      </el-row>
                      <el-row>
                            <el-col :span="12" >
                              <el-form-item  label="申请人">
                                <el-input readonly v-model="formInfo.applyUserName"  ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                              <el-form-item  label="申请所属部门">
                                <el-input readonly v-model="formInfo.applyUserDept"></el-input>
                              </el-form-item>
                            </el-col>
                      </el-row>
                      <el-row>
                          <el-col :span="12" >
                            <el-form-item label="申请时间">
                              <el-input readonly v-model="formInfo.applyUserCreated" ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12" >
                          <el-form-item label="审批状态">
                              <el-input readonly v-model="formInfo.approvalStatus" ></el-input>
                            </el-form-item> 
                          </el-col>
                      </el-row>
                  </el-form>
                </div>
                <div style="">
                    <el-form label-width="165px"> 
                       <el-row>
                            <div style="margin-top: 20px; padding-left: 25mm;font-size: large; margin-bottom: 5px;font-size: large;color: #333;font-weight: 700;">表单信息</div>
                      </el-row>
                      <FieldItem v-for="(field,index2) in formInfo.fieldsList" :findex="index2" ref="fieldItemChild" :formId="formInfo.id" :key="field.fieldId" :field="field" :formData="formInfo.values" :colSpan="formInfo.colSpan" :isRead="isRead" :fieldsList="formInfo.fieldsList"/>
                    </el-form>
                </div>
                <div v-if="isShowApproval && formInfo.approvalRecordList" style="width:340mm;padding-left: 25mm;">
                  <div style="margin-top: 20px;float: left;font-size: large; margin-bottom: 5px;font-size: large;color: #333;font-weight: 700;">审批记录</div>
                  <el-form label-width="165px"> 
                    <el-row>
                      <el-table :data="formInfo.approvalRecordList" :border="true" style="width:340mm;">
                        <el-table-column
                        type="index"
                        width="30">
                        </el-table-column>
                        <el-table-column
                            label="审批人"
                            prop="trueName"
                            :show-overflow-tooltip="true"
                            align="center"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            label="审批状态"
                            align="center"
                            width="100">
                            <template slot-scope="scope">
                              <el-button size="mini" type="info" v-if="scope.row.approvalResult==0" round>未处理</el-button>
                              <el-button size="mini" type="success" v-if="scope.row.approvalResult==1" round>通过</el-button>
                              <el-button size="mini" type="danger"  v-if="scope.row.approvalResult==2" round>驳回</el-button>
                            </template>
                        </el-table-column>
                            <el-table-column
                            label="审批时间"
                            align="center"
                            prop="approvalDate"
                            width="150">
                        </el-table-column>
                            <el-table-column
                            label="审批意见"
                            align="center"
                            :show-overflow-tooltip="true"
                            prop="approvalRemarks"
                            width="1000"
                            >
                        </el-table-column>
                      </el-table>
                    </el-row>
                  </el-form>
                </div>
            </div> 
         </div>
      </div>
    <!-- </div> -->
</template> 

<script>
 import { API_IMG_DOWNLOAD } from '@/common/constants';
 export default {
     data () {
         return {
             imageUrl: '',
             companyName: '',
             companyInfo: {},
             isPrintPage: true,
             isRead: true,
             pdfTitle: this.formInfo.formName, // 填入导出的pdf文件名和html元素
             pdfSelector: '#printId' // 填入导出的html元素
         };
     },
     props: {
         formInfo: {
             type: Object
         },
         isShowApproval: {
             type: Boolean,
             default: false
         }
     },
     filters: {// 如下这样写
         getCurrentTime: function () {
             let yy = new Date().getFullYear();
             let mm = new Date().getMonth() + 1;
             let dd = new Date().getDate();
             let hh = new Date().getHours();
             let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
             let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
             let currentTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
             return currentTime;
         }
     },
     created () {
         this._initData();
         let currentUserStr = sessionStorage.getItem('currentUserInfo');
         if (currentUserStr) {
             let currentUserInfo = JSON.parse(currentUserStr);
             this.companyInfo = currentUserInfo.companyInfo;
             this.companyName = currentUserInfo.companyInfo.companyName;
             // console.log(this.companyName);
         }
         this.setCompanyLogo();
     },
     methods: {
         _initData () {
             // console.log("打印");
             // console.log(this.formInfo);
         },
         //  async refCompany () {
         //      this.companyInfo = await getMyCompanyDetail();
         //      console.log(this.companyInfo);
         //      this.setCompanyLogo();
         //  },
         setCompanyLogo () {
             let prefix = '';
             let logoUrl = '';
             let env = process.env.NODE_ENV;
             if (env === 'production') {
                 prefix = '/bcbpm';
             }
             if (this.companyInfo.companyLogo) {
                 logoUrl = `${API_IMG_DOWNLOAD}${this.companyInfo.companyLogo}`;
             } else {
                 logoUrl = prefix + '/images/default.png';
             }
             this.imageUrl = logoUrl;
         },
         async createPdf () {
             this.$confirm(`导出pdf文件需要您耐心等待大概5~10秒时间,期间请勿重复点击导出按钮。`, '提示', {
                 confirmButtonText: '确定导出',
                 cancelButtonText: '取消',
                 type: 'warning'
             }).then(async (res) => {
                 this.getPdf('#printId');
             }).catch(() => {});
         }
 
     }
 };
</script>
 <!-- <style lang="less" scoped> -->
<style lang="less"> 
    .printUtilApprove-modelDetail { 
        width: 98%;
        height: auto;
        margin-top: -3%;
        // overflow-y: auto;
        .model-content {
            // width:380mm;//打印需要设置单位为mm，否则无法打印多列情况
            // flex: 1;
            display:inline-block;
            // flex-direction: row;
            .el-form-item__label{
              color: #333;
              font-weight: 530;
            }
            .content-left {
              width: 100%;
              // margin: 0 15px 0 0;
              .el-card__body{
                padding: 0px
              }
            }
            .form-title {
                text-align: center;
                font-size: large;
                margin-bottom: 15px;
            }
            .el-table--scrollable-x .el-table__body-wrapper{//打印确认页的滚动取消
                overflow-x: hidden;
            }
        }
        .button-view {
            float:right;
        }
        .el-input.is-disabled .el-input__inner {
          color: #333;
        }
        .el-textarea.is-disabled .el-textarea__inner{
           color: #333;
        }
        .el-form-item--small.el-form-item{
          margin-bottom: 0px;
        }
        .render-form-item {
          .el-input--small .el-input__inner {
              margin-top: 0px;
          }
        }
      .avatar-wrapper {
          cursor: pointer;
          margin-top: -4px;
          // margin-left: 1px;
          position: relative;
          padding-left: 5mm;
          .logo-avatar {
              width: 50px;
              height: 50px;
              border-radius: 10px;
          }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/PrintUtil/PrintUtilApprove.vue